import {
    MDBAlert,
    MDBBtn,
    MDBIcon,
    MDBRadio,
    MDBSpinner
} from "mdb-react-ui-kit";
import React, { useEffect, useRef, useState } from 'react';
import { useForm } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router';
import { Tooltip } from 'react-tooltip';

function AccLoginSettings({ register, setValue, errors, watch }) {
    const { t, i18n } = useTranslation();


    return (
        <>
            {/* <div className="general-settings">Multi Login Settings</div> */}
            <div className="add-numbermain">
                <div className="tel-numbers">
                    Multiple logins for the same user
                    {/* Added subtext Jerome's Enhancements suggested changes */}
                    <p className='phrecording text-secondary'>
                        A user can be logged in to the desktop app with two concurrent sessions and to the mobile app with two concurrent sessions.
                    </p>
                </div>
                <div className="phoneselect w-30">
                    <div>
                        <label className="switch">
                            <input className="form-control" type="checkbox" {...register("global_settings.streams_settings.logins")} />
                            <span className="slider round"></span>
                        </label>
                    </div>
                </div>
            </div>

            {watch("global_settings.streams_settings.logins") && (

                <div className="add-numbermain">
                    <div className="tel-numbers">
                        Allow users to modify this setting
                    </div>
                    <div className="phoneselect w-30">
                        <div>
                            <label className="switch">
                                <input className="form-control" type="checkbox" {...register("global_settings.streams_settings.allow_users")} />
                                <span className="slider round"></span>
                            </label>
                        </div>
                    </div>
                </div>
            )}



            {/* <div> */}
            {/* Hide the Single_Sign-On according to Jerome's Enhancements suggested changes */}

            {/* {show_links_tab == 1 && (
                    <div className="add-numbermain">
                        <div className="tel-numbers mt-4">
                            <strong>{t("simgleSignon")}</strong>          <br />
                            <span className="phrecording text-secondary">
                                Single Sign-On lets your users sign in using an existing supported identity provider.
                            </span>
                        </div>
                        <div className="phoneselect w-30">
                            <div className="w-100">
                                <label className="switch">
                                    <input className="form-control" type="checkbox" {...register("global_settings.single_signon.sso_enabled")} />
                                    <span className="slider round"></span>
                                </label>
                                {errors?.global_settings?.single_signon?.sso_enabled && (
                                    <p className="text-danger">{errors?.global_settings?.single_signon?.sso_enabled?.message}</p>
                                )}
                            </div>
                        </div>
                    </div>
                )} */}
            {/*                 
                {watch("global_settings.single_signon.sso_enabled") && (
                    <>

                        <div className="tel-numbers mt-4">
                            <strong>Single Sign-On lets your users sign in using an existing supported identity provider</strong>
                        </div>

                        <div className="mt-4">
                            <MDBRadio
                                id='inlineRadio1'
                                value={0}
                                checked={watch("global_settings.single_signon.login_option") === 0}
                                label='Users will be able to sign in with either their SmartBox or Single Sign-On credentials'
                                onChange={(e) => setValue("global_settings.single_signon.login_option", 0, { shouldDirty: true })}
                            />
                        </div>
                        <div className="mt-4">
                            <MDBRadio
                                id='inlineRadio2'
                                value={1}
                                checked={watch("global_settings.single_signon.login_option") === 1}
                                label='Users will be required to sign in with their Single Sign-On credentials'
                                onChange={(e) => setValue("global_settings.single_signon.login_option", 1, { shouldDirty: true })}
                            />
                        </div>
                        {errors?.global_settings?.single_signon?.login_option && (
                            <p className="text-danger">{errors?.global_settings?.single_signon?.login_option?.message}</p>
                        )}

                        <div>
                            <div className="tel-numbers mt-4">
                                Sign in URL<MDBIcon far icon="question-circle" className="ms-2 tootltipsignin" />
                            </div>
                            <div className="form-outline w-80 mt-3">
                                <input type="text" className="form-control" {...register("global_settings.single_signon.sign_in_url")} />
                                {errors?.global_settings?.single_signon?.sign_in_url && (
                                    <p className="text-danger">{errors?.global_settings?.single_signon?.sign_in_url?.message}</p>
                                )}
                            </div>
                        </div>

                        <div className="tel-numbers mt-4">
                            X.509 Certificate<MDBIcon far icon="question-circle" className="ms-2 tootltipsign" />
                        </div>


                        <div className="tel-numbers mt-4">
                            Comently using OneLogin Account. Expires On {watch("global_settings.single_signon.expiry_date")}
                        </div>
                        <div className="tel-numbers mt-2">
                            Update certificate drag, drop, or browse
                        </div>
                        <div className="w-80 mt-3">
                            <div className="uploadOuter">
                                <span
                                    className="dragBox upload-content py-5 bg-light"
                                    onDragOver={handleDragOver}
                                    onDrop={handleDrop}
                                >
                                    <span className="line-h20 d-flex flex-column text-secondary">
                                        <img src={uploadIcon} className="upload-img" />
                                        Browse
                                    </span>
                                    <span className="text-secondary mt-2">Drag & drop to upload Certificate</span>


                                    <input
                                        type="file"
                                        id="uploadFile"
                                        className="upload__img"
                                        onChange={handleFileChange}
                                    />
                                </span> */}
            {/* <div id="preview" ref={previewRef}></div> */}
            {/* </div>
                        </div>

                        <div className="tel-numbers mt-4"> */}
            {/* Certificate Size: 2MB */}
            {/* </div>
                        <div className="tel-numbers mt-4 mb-5 pb-5">
                            <strong>Note: </strong>Currently, SmartBox Supports Single Sign-On for OneLogin and Okta identity providers.
                        </div>
                    </>
                )} */}



            {/* </div> */}
          
          

            <Tooltip anchorSelect=".tootltipsign" place="top" className="exampleTooltip">
                This should be a valid certificate that comes from your identity provider.
            </Tooltip>

            <Tooltip anchorSelect=".tootltipsignin" place="top" className="exampleTooltip">
                Your users will be redirected to this page to sign in.
            </Tooltip>

        </>
    )
}

export default AccLoginSettings;

// export async function encryptToBase64(data) {
//     return new Promise((resolve, reject) => {
//         try {
//             resolve(Buffer.from(data).toString('base64'));
//         } catch (e) {
//             reject(-1);
//         }
//     });
// }

export async function encryptToBase64(file) {
    return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => {
            const base64String = reader.result.split(',')[1]; // Remove the prefix
            resolve(base64String);
        };
        reader.onerror = (error) => reject(error);
    });
}
